/** Analytics */

export const GET_DASHBOARD_USER_FILTERED_KPIS = 'GET_DASHBOARD_USER_FILTERED_KPIS';
export const GET_DASHBOARD_USER_FILTERED_KPIS_SUCCESS = 'GET_DASHBOARD_USER_FILTERED_KPIS_SUCCESS';
export const GET_DASHBOARD_ALL_KPIS = 'GET_DASHBOARD_ALL_KPIS';
export const GET_DASHBOARD_ALL_KPIS_SUCCESS = 'GET_DASHBOARD_ALL_KPIS_SUCCESS';
export const GET_DASHBOARD_USER_KPIS = 'GET_DASHBOARD_USER_KPIS';
export const GET_DASHBOARD_USER_KPIS_SUCCESS = 'GET_DASHBOARD_USER_KPIS_SUCCESS';
export const DELETE_DASHBOARD_USER_KPI = 'DELETE_DASHBOARD_USER_KPI';
export const ADD_DASHBOARD_USER_KPI = 'ADD_DASHBOARD_USER_KPI';
export const REORDER__DASHBOARD_KPIS = 'REORDER__DASHBOARD_KPIS';

/** Upcoming Appointments */
export const GET_DASHBOARD_UPCOMING_APPTS = 'GET_DASHBOARD_UPCOMING_APPTS';
export const GET_DASHBOARD_UPCOMING_APPTS_SUCCESS = 'GET_DASHBOARD_UPCOMING_APPTS_SUCCESS';
/** End */

/** Clients Overview */
export const GET_DASHBOARD_CLIENTS_OVERVIEW = 'GET_DASHBOARD_CLIENTS_OVERVIEW';
export const GET_DASHBOARD_CLIENTS_OVERVIEW_SUCCESS = 'GET_DASHBOARD_CLIENTS_OVERVIEW_SUCCESS';
/** End */

/** Clients Overview */
export const GET_DASHBOARD_ASSIGNED_CLIENTS = 'GET_DASHBOARD_ASSIGNED_CLIENTS';
export const GET_DASHBOARD_ASSIGNED_CLIENTS_SUCCESS = 'GET_DASHBOARD_ASSIGNED_CLIENTS_SUCCESS';
/** End */

/** Clients Overview */
export const GET_DASHBOARD_CREDENTIAL_ALERTS = 'GET_DASHBOARD_CREDENTIAL_ALERTS';
export const GET_DASHBOARD_CREDENTIAL_ALERTS_SUCCESS = 'GET_DASHBOARD_CREDENTIAL_ALERTS_SUCCESS';
/** End */

/** My Tasks */
export const GET_DASHBOARD_MY_TASKS = 'GET_DASHBOARD_MY_TASKS';
export const GET_DASHBOARD_MY_TASKS_SUCCESS = 'GET_DASHBOARD_MY_TASKS_SUCCESS';
/** End */

/** Expiring Authorizations */
export const GET_DASHBOARD_EXPIRING_AUTHS = 'GET_DASHBOARD_EXPIRING_AUTHS';
export const GET_DASHBOARD_EXPIRING_AUTHS_SUCCESS = 'GET_DASHBOARD_EXPIRING_AUTHS_SUCCESS';
/** End */

/** Insurance Alerts */
export const GET_DASHBOARD_INSURANCE_ALERTS = 'GET_DASHBOARD_INSURANCE_ALERTS';
export const GET_DASHBOARD_INSURANCE_ALERTS_SUCCESS = 'GET_DASHBOARD_INSURANCE_ALERTS_SUCCESS';

/** Client Document Alerts */
export const GET_DASHBOARD_CLIENT_DOCUMENT_ALERTS = 'GET_DASHBOARD_CLIENT_DOCUMENT_ALERTS';
export const GET_DASHBOARD_CLIENT_DOCUMENT_ALERTS_SUCCESS = 'GET_DASHBOARD_CLIENT_DOCUMENT_ALERTS_SUCCESS';

export const GET_DASHBOARD_SESSION_NOTE_REQUESTS = 'GET_DASHBOARD_SESSION_NOTE_REQUESTS';
export const GET_DASHBOARD_SESSION_NOTE_REQUESTS_SUCCESS = 'GET_DASHBOARD_SESSION_NOTE_REQUESTS_SUCCESS';
/** End */
